/// <amd-module name="TFS/Admin/Views/OrgGroups/Components/GroupsHub" />
import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ConnectedGroupsPageContentView } from "TFS/Admin/Views/OrgGroups/Components/GroupsPageContentView";
import { getOrganizationGroupsModule } from "TFS/Admin/Views/OrgGroups/redux/OrganizationGroupsModule";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";
import { IRootProviderProps, RootProvider } from "VSS/Redux/RootProvider";
import { getGroupsHubRootProviderProps, IGroupsHubSagaContext } from "TFS/Admin/Views/OrgGroups/redux/OrganizationGroupsRootProviderProps";

export interface IOrganizationPermissionsProps {}

export class GroupsHub extends VssComponent<IOrganizationPermissionsProps> {
    private _hubViewState: VssHubViewState;
    private _context: IVssComponentContext;
    private rootProviderProps: IRootProviderProps<IGroupsHubSagaContext, any>;

    constructor(props: IOrganizationPermissionsProps, context: IVssComponentContext) {
        super(props, context);

        this._context = context;

        this.rootProviderProps = getGroupsHubRootProviderProps(this.context.pageContext);
    }

    public render(): JSX.Element {
        this._initializeHubState(this._context);

        return (
            <RootProvider {...this.rootProviderProps}>
                <DynamicModuleLoader modules={[getOrganizationGroupsModule()]}>
                    <ConnectedGroupsPageContentView hubViewState={this._hubViewState} context={this._context} />
                </DynamicModuleLoader>
            </RootProvider>
        );
    }

    // Hub initializer functions
    private _initializeHubState(context: IVssComponentContext): void {
        this._hubViewState = new VssHubViewState(context.pageContext);
    }
}

VssComponent.register("orgGroupsView", GroupsHub);
